import { Component, Inject, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { GlobalService } from "@frontend/app/serivces/global.service";
import { ToastrService } from "ngx-toastr";
import { MasterService } from "@frontend/app/serivces/master.service";
import { FormsModule } from "@angular/forms";
import { NavigationMenuComponent } from "../navigation-menu/navigation-menu.component";

@Component({
  selector: "app-usertype-master-entry",
  standalone: true,
  imports: [CommonModule, FormsModule, NavigationMenuComponent],
  templateUrl: "./usertype-master-entry.component.html",
  styleUrl: "./usertype-master-entry.component.scss",
})
export class UsertypeMasterEntryComponent implements OnInit {
  private dialogService = inject(MatDialog);
  private toastr = inject(ToastrService);
  private globalService = inject(GlobalService);
  private masterService = inject(MasterService);

  constructor(@Inject(MAT_DIALOG_DATA) data: DialogData | null) {
    if (data) {
      this.UserTypeId = data.UserTypeID ?? 0;
      this.UserType = data.UserType ?? "";
      this.IsEdit = data.IsEdit ?? false;
      this.dialogHandler(data);
    }
  }

  ngOnInit(): void {
    if (!this.IsEdit) {
      this.getMasterMenu();
    }
  }

  UserTypeId = 0;
  UserType?: string;
  IsActive = true;
  MenuDetails: any[] = [];
  IsEdit = false;
  MasterMenuList: any[] = [];
  ErrorMessageList: string[] = [];
  selectedMenu: any[] = [];

  dialogHandler(data: DialogData) {
    this.UserTypeId = data.UserTypeID;
    this.IsEdit = data.IsEdit;
    if (this.IsEdit) {
      this.getUserTypeByID();
    }else{
      this.getMasterMenu();

  }
  }

  getMasterMenu() {
    this.masterService.getMenuList().subscribe((res: any) => {
      const { Table } = res;
      if (Table?.length) {
        this.MasterMenuList = this.globalService.menuSetter(Table);
      }
    });
  }

  getUserTypeByID() {
    this.masterService.GetUserTypeByID(this.UserTypeId).subscribe((res: any) => {
      const { Table } = res;

      if (Table?.length) {
        const firstMenu = Table[0];
        const permission = firstMenu?.MenuWithPermissions?.[0];

        if (permission) {
          this.UserTypeId = permission.UserTypeID;
          this.UserType = permission.UserTypeWithName?.UserType ?? permission.UserType ?? "";
          this.IsActive = permission.UserTypeWithName?.IsActive ?? permission.IsActive ?? true;

          if (!this.UserType) {
            console.warn("UserType could not be determined from response.");
          }
        }

        this.MasterMenuList = this.globalService.menuSetter(Table);
      }
    });
  }

  validateForm(): boolean {
    let isValid = true;
    this.ErrorMessageList = [];
    this.selectedMenu = this.globalService.reformatMenu(this.MasterMenuList || []);

    if (!this.UserType?.trim()) {
      this.ErrorMessageList.push("UserType Name");
    }

    const canAddSelected = this.selectedMenu.find(item => item.canAdd);
    const canEditSelected = this.selectedMenu.find(item => item.canEdit);
    const canDeleteSelected = this.selectedMenu.find(item => item.canDelete);

    if (!canAddSelected && !canEditSelected && !canDeleteSelected) {
      this.ErrorMessageList.push("Menu Not Selected");
    }

    if (this.ErrorMessageList.length) {
      isValid = false;
      this.toastr.error("Please fill all required fields.", "Info");
    }

    return isValid;
  }

  onSubmit() {
    this.selectedMenu = this.globalService.reformatMenu(this.MasterMenuList || []);

    const requestData = {
      UserTypeID: this.UserTypeId ? this.UserTypeId.toString() : "0",
      UserType: this.UserType || "",
      IsActive: this.IsActive,
      MenuPermissions: this.selectedMenu.map(menu => ({
        MenuID: menu.MenuID.toString(),
        CanAdd: menu.CanAdd,
        CanEdit: menu.CanEdit,
        CanDelete: menu.CanDelete,
        CanView: true,
      })),
    };
    this.masterService.addMenuPermission(requestData).subscribe({
      next: res => {
        this.toastr.success(this.IsEdit ? "User type updated." : "User type created.");
        this.dialogService.closeAll();
      },
      error: err => {
        console.error(err);
        this.toastr.error("Failed to save user type.");
      },
    });
  }
}

interface DialogData {
  IsEdit: boolean;
  UserTypeID: number;
  UserType: string;
}
